import { CalendarSurfaceStore } from 'owa-calendar-surface-dategrid';
import { mutatorAction } from 'satcheljs';

export let updateGridBounds = mutatorAction('updateGridBounds', function updateGridBounds(
    store: CalendarSurfaceStore
) {
    if (store.calendarDayListBounds) {
        const { gridViewRefs, allDayPanelViewRefs, inDayScrollRef } = store.calendarDayListBounds;
        if (gridViewRefs && gridViewRefs.length > 0) {
            gridViewRefs.forEach(g => (g.bounds = g.element.getBoundingClientRect()));
        }

        if (allDayPanelViewRefs && allDayPanelViewRefs.length > 0) {
            allDayPanelViewRefs.forEach(g => (g.bounds = g.element.getBoundingClientRect()));
        }

        if (inDayScrollRef) {
            inDayScrollRef.bounds = inDayScrollRef.element.getBoundingClientRect();
        }
    }
});
